import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang-context";
import { CITIES } from "@/lib/seo-cities";

/**
 * Footer doubles as the site's secondary navigation: it surfaces all SEO
 * landing pages (cities, FAQ, glossary) and the legal Privacy link. The
 * cross-linking gives both users a way to discover content and Google a
 * clear sitemap of internal links.
 */
export const Footer = () => {
  const { t } = useLang();
  const cities = Object.values(CITIES);
  return (
    <footer
      data-testid="site-footer"
      className="mt-32 border-t border-[#E6E4DD] bg-[#F0EFEB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="font-serif-display text-2xl text-[#282C2A]">
            Deal Rating
          </div>
          <div className="label-eyebrow mt-1">Lecce — Brindisi — Taranto</div>
          <p className="mt-3 text-xs text-[#6C706D] font-mono leading-relaxed">
            {t("footer.tag")}
          </p>
        </div>

        <div>
          <div className="label-eyebrow mb-3">{t("footer.cities")}</div>
          <ul className="space-y-1.5 text-sm">
            {cities.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/citta/${c.slug}`}
                  data-testid={`footer-city-${c.slug}`}
                  className="text-[#282C2A] hover:text-[#4A5D23] transition-colors"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="label-eyebrow mb-3">{t("footer.resources")}</div>
          <ul className="space-y-1.5 text-sm">
            <li>
              <Link
                to="/faq"
                data-testid="footer-faq-link"
                className="text-[#282C2A] hover:text-[#4A5D23] transition-colors"
              >
                FAQ
              </Link>
            </li>
            <li>
              <Link
                to="/glossario"
                data-testid="footer-glossary-link"
                className="text-[#282C2A] hover:text-[#4A5D23] transition-colors"
              >
                Glossario
              </Link>
            </li>
            <li>
              <Link
                to="/mappa-prezzi-salento"
                data-testid="footer-map-link"
                className="text-[#282C2A] hover:text-[#4A5D23] transition-colors"
              >
                Mappa prezzi
              </Link>
            </li>
            <li>
              <Link
                to="/blog"
                data-testid="footer-blog-link"
                className="text-[#282C2A] hover:text-[#4A5D23] transition-colors"
              >
                Blog
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="label-eyebrow mb-3">{t("footer.legal")}</div>
          <ul className="space-y-1.5 text-sm">
            <li>
              <Link
                to="/privacy"
                data-testid="footer-privacy-link"
                className="text-[#282C2A] hover:text-[#4A5D23] transition-colors"
              >
                {t("footer.privacy")}
              </Link>
            </li>
            <li className="text-xs text-[#6C706D] mt-3 font-mono">
              info@dealrating.it
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
